export default __webpack_public_path__ + "static/media/Darkblade's Hood of the Kingmaker.266f75ae.jpg";